export const calcularTamanhoFonte = (type) => {
    const larguraTela = window.innerWidth;
    switch (type) {
        case type === 'label':
            if (larguraTela > 2100) return 22;
            if (larguraTela > 1400) return 18;
            if (larguraTela > 1200) return 14;
            if (larguraTela > 800) return 10;
            return 12;
        case type === 'scales':
            if (larguraTela > 2100) return 22;
            if (larguraTela > 1400) return 18;
            if (larguraTela > 1200) return 14;
            if (larguraTela > 800) return 10;
            return 12;
        case type === 'datalabel':
            if (larguraTela > 2100) return 28;
            if (larguraTela > 1400) return 24;
            if (larguraTela > 1200) return 20;
            if (larguraTela > 800) return 16;
            return 12;
        default:
            if (larguraTela > 2100) return 28;
            if (larguraTela > 1400) return 24;
            if (larguraTela > 1200) return 20;
            if (larguraTela > 800) return 16;
            return 12;
    }
};

